class Anchor {
  constructor() {
    this.header = document.querySelector('.iz-header');
    this.hashlinks = Array.from(document.querySelectorAll('a[href*="#"]'));
      //  this.hashlinks = Array.from(document.querySelectorAll('a.mms-link[href*="#"]'));
    this.addScrollTo();
    this.handleInitialHash();
  }

  addScrollTo() {
    if (this.hashlinks.length === 0) return;

    this.hashlinks.forEach(link => {

      const hash = link.getAttribute('href').split('#')[1];

      if (hash) {
        const targetElement = document.querySelector("#" + hash);
        if (targetElement) {

          link.addEventListener('click', (event) => {
            if (link.classList.contains('lc-quick-access-archiv__link')) {
              return;
            }

            event.preventDefault();

            setTimeout(() => {
              const popupBackground = document.querySelector(".iz-notes__background");
              if (popupBackground) {
                const event = new Event("click", { bubbles: true, cancelable: true });
                popupBackground.dispatchEvent(event);
              }
            }, 250);

            const targetHash = `#${hash}`;
            this.openAccordionAndScroll(targetHash);
          });
        }
      };
    });
  }

  handleInitialHash() {
    setTimeout(() => {
      if (window.location.hash) {
        const hash = decodeURIComponent(window.location.hash);
        this.openAccordionAndScroll(hash);
      }
    }, 50);
  }

  openAccordionAndScroll(hash) {
    const targetElement = document.querySelector(hash);
    if (!targetElement) return;

    const accordion = targetElement.closest('.lc-accordion');
    if (accordion && !accordion.classList.contains('is-open')) {
      this.openAccordion(accordion, () => {
        this.scrollToElementWithOffset(targetElement);
      });
    } else {
      this.scrollToElementWithOffset(targetElement);
    }
  }

  // openAccordion(accordion, callback) -- old {
  //   if (accordion.classList.contains('is-open')) return;

  //   accordion.classList.add('is-open');

  //   const innerHead = accordion.querySelector('.lc-accordion__inner-head');
  //   if (innerHead) {
  //     innerHead.classList.add('active');
  //   }

  //   const content = accordion.querySelector('.lc-accordion__content');
  //   if (content) {
  //     content.classList.add('active');
  //     content.style.height = "auto";
  //     content.style.maxHeight = "";
  //   }

  //   setTimeout(() => {
  //     if (callback) callback();
  //   }, 300);
  // }

  openAccordion(accordion, callback) {
    if (accordion.classList.contains('is-open')) return;

    accordion.classList.add('is-open');
    accordion.setAttribute('data-anchor-triggered', 'true');

    const innerHead = accordion.querySelector('.lc-accordion__inner-head');
    if (innerHead) {
      innerHead.classList.add('active');
    }

    const content = accordion.querySelector('.lc-accordion__content');
    if (content) {
      content.classList.add('active');
      content.style.height = "auto";
      content.style.maxHeight = "";
    }

    setTimeout(() => {
      if (callback) callback();
    }, 300);
  }

  scrollToElementWithOffset(targetElement) {
    setTimeout(() => {
      const offset = this.header ? this.header.clientHeight + 20 : -30;
      const distanceToScroll = targetElement.getBoundingClientRect().top + window.scrollY - offset;

      if ("scrollBehavior" in document.documentElement.style) {
        window.scrollTo({ top: distanceToScroll, behavior: "smooth" });
      } else {
        window.requestAnimationFrame(() => {
          window.scrollTo(0, distanceToScroll);
        });
      }
    }, 300);
  }
}

export default Anchor;
